function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.085,21.389C11.633,21.389 11.237,21.226 10.9,20.898C10.562,20.571 10.393,20.113 10.393,19.524C10.393,19.002 10.557,18.563 10.883,18.206C11.21,17.85 11.61,17.672 12.085,17.672C12.553,17.672 12.946,17.85 13.265,18.206C13.584,18.563 13.744,19.002 13.744,19.524C13.744,20.105 13.577,20.56 13.243,20.892C12.909,21.224 12.523,21.389 12.085,21.389ZM6.653,7.763C6.653,6.975 6.88,6.177 7.332,5.369C7.785,4.561 8.445,3.892 9.314,3.361C10.182,2.831 11.195,2.566 12.352,2.566C13.428,2.566 14.378,2.787 15.202,3.231C16.025,3.674 16.662,4.277 17.111,5.04C17.56,5.802 17.784,6.631 17.784,7.526C17.784,8.231 17.656,8.848 17.4,9.379C17.144,9.909 16.84,10.367 16.487,10.753C16.135,11.138 15.502,11.787 14.59,12.699C14.337,12.956 14.135,13.181 13.983,13.376C13.831,13.571 13.718,13.749 13.643,13.911C13.569,14.072 13.512,14.234 13.471,14.396C13.43,14.557 13.369,14.841 13.287,15.247C13.146,16.109 12.705,16.54 11.963,16.54C11.577,16.54 11.252,16.4 10.989,16.118C10.725,15.836 10.594,15.417 10.594,14.862C10.594,14.166 10.69,13.563 10.883,13.053C11.076,12.543 11.332,12.096 11.651,11.71C11.97,11.325 12.401,10.867 12.942,10.336C13.417,9.872 13.76,9.522 13.972,9.286C14.183,9.049 14.361,8.786 14.506,8.496C14.651,8.206 14.723,7.891 14.723,7.551C14.723,6.888 14.502,6.329 14.061,5.873C13.619,5.417 13.05,5.189 12.352,5.189C11.536,5.189 10.935,5.419 10.549,5.879C10.163,6.339 9.837,7.017 9.57,7.912C9.317,8.848 8.839,9.317 8.134,9.317C7.718,9.317 7.368,9.153 7.082,8.826C6.796,8.498 6.653,8.144 6.653,7.763Z",
    style: {
      fill: "rgb(0,53,65)",
      fillOpacity: 0.4,
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.0a00c2e8cb2e3ad10652e042d788ffd0.svg";
export { ForwardRef as ReactComponent };